export type ClearServiceWorkerAndCachesOptions = {
  logPrefix?: string;
};

/**
 * Best-effort で Service Worker / Cache Storage をクリアする。
 * 各ステップは独立して try/catch し、失敗しても全体を中断しない。
 *
 * localStorage / sessionStorage 等の Web Storage は対象外で、意図的に保持する
 * （クリアが必要な場合は呼び出し元が `clearAuthState` 等で個別に行う）。
 */
export async function clearServiceWorkerAndCaches(
  options: ClearServiceWorkerAndCachesOptions = {},
): Promise<void> {
  const { logPrefix = "[cache-clear]" } = options;

  if (typeof window === "undefined") return;

  // Cache Storage
  try {
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map(async (name) => {
          try {
            await caches.delete(name);
          } catch (error) {
            console.warn(`${logPrefix} caches.delete failed:`, name, error);
          }
        }),
      );
    }
  } catch (error) {
    console.warn(`${logPrefix} caches.keys failed:`, error);
  }

  // Service Worker registrations
  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations.map(async (registration) => {
          try {
            await registration.unregister();
          } catch (error) {
            console.warn(`${logPrefix} sw.unregister failed:`, error);
          }
        }),
      );
    }
  } catch (error) {
    console.warn(`${logPrefix} sw.getRegistrations failed:`, error);
  }
}
